import { useState } from 'react';
import clsx from 'clsx';
import Checkbox from 'components/checkbox';
import TextInput from 'components/text-input';
import LoadMoreButton from 'components/load-more-button';
import ClearInputButton from 'components/clear-input-button';

import magnifier from 'assets/images/magnifier.svg';
import styles from './styles.module.scss';

type CheckboxListProps = {
  items: { id: number; label: string }[];
  selected: Set<number>;
  onChange: (idx: number) => void;
  onClear: () => void;
  withSearch?: boolean;
};

const initNum = 4;

const CheckboxList: React.FC<CheckboxListProps> = (props) => {
  const { items, selected, onChange, onClear, withSearch } = props;

  const [search, setSearch] = useState('');
  const [showNumber, setShowNumber] = useState(initNum);

  const canShowMore = items.length > initNum;
  const isExpanded = showNumber === items.length;

  return (
    <div className={styles.container}>
      {withSearch && (
        <TextInput
          placeholder='Найти'
          icon={magnifier}
          value={search}
          onChange={setSearch}
          className={styles.search}
        />
      )}

      {items.slice(0, search === '' ? showNumber : undefined).map((i) => {
        const isHidden = search !== '' && !i.label.toLowerCase().includes(search.toLowerCase());

        return (
          <Checkbox
            key={i.id}
            label={i.label}
            checked={selected.has(i.id)}
            className={clsx(styles.checkbox, isHidden && styles.hidden)}
            onChange={() => onChange(i.id)}
          />
        );
      })}

      <div className={styles.buttons}>
        <ClearInputButton onClick={onClear} />

        {canShowMore && search === '' && (
          <LoadMoreButton
            className={styles.expandButton}
            label={isExpanded ? 'Скрыть' : `Показать ещё ${items.length - showNumber}`}
            onClick={() => setShowNumber(isExpanded ? initNum : items.length)}
          />
        )}
      </div>
    </div>
  );
};

export default CheckboxList;
